<template>
  <v-card style="z-index: 9999">
    <v-card-title class="headline"
      >Confirmar acción
      <v-btn
        style="right: 10px; top: 10px"
        icon
        color="primary"
        fab
        absolute
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <h3 class="mt-5">¿Está seguro que desea salir?</h3>
      <p>La ruta definida será eliminada.</p>
    </v-card-text>

    <v-card-actions style="justify-content: center">
      <v-btn
        color="gray"
        dark
        class="mb-3"
        rounded
        :min-height="48"
        @click="$emit('cancel')"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="primary"
        dark
        class="mb-3"
        rounded
        :min-height="48"
        @click="$emit('confirm')"
      >
        Salir
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "comfirm",
};
</script>